import axios from 'axios';
import { getKjederegAdminApiUrl } from '../../';
import { AlkoholbevillingDashboardDto } from './types';

const baseUrl = getKjederegAdminApiUrl() + '/alkoholbevillinger';

const AlkoholbevillingImportApi = {
  getDashboard: async (days = 14): Promise<AlkoholbevillingDashboardDto> => {
    const response = await axios.get(`${baseUrl}/dashboard`, { params: { days } });
    return response.data;
  },

  exportToExcel: async (): Promise<{ blob: Blob; fileName: string }> => {
    const response = await axios.get(`${baseUrl}/export`, {
      responseType: 'blob',
    });

    const contentDisposition = response.headers?.['content-disposition'] as string | undefined;
    const fileNameMatch = contentDisposition?.match(
      /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i,
    );
    const fileName = decodeURIComponent(
      fileNameMatch?.[1] ?? fileNameMatch?.[2] ?? 'alkoholbevillinger.xlsx',
    );
    return { blob: response.data as Blob, fileName };
  },
};

export default AlkoholbevillingImportApi;
